import { Component, signal, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { environment } from '../environments/environment';
import { ThemeService } from './shared/services/theme.service';
import { UpdateService } from './shared/services/update.service';
import packageConf from '../../package.json';
import { NzLayoutModule } from 'ng-zorro-antd/layout';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, NzLayoutModule],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App {
  protected readonly title = signal('service-manager');
  private themeService = inject(ThemeService);
  private updateService = inject(UpdateService);
  isProd = environment.production;
  version = packageConf.version;

  constructor() {
    if (!this.isProd) {
      console.log('VERSION:', packageConf.version);
    }
  }
}
